import { render, staticRenderFns } from "./AchievementItem.vue?vue&type=template&id=a857a414"
import script from "./AchievementItem.vue?vue&type=script&lang=js"
export * from "./AchievementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports